var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('page-header',[_c('span',{attrs:{"slot":"header-title"},slot:"header-title"},[_vm._v(_vm._s(_vm.$t("ROOM_INFOMATION")))])]),_c('left-menu'),_c('list-room')],1)}
var staticRenderFns = []

export { render, staticRenderFns }